import { globalColorsNBD, invertedThemeColorsNBD, mainThemeColorsNBD } from '@volkswagen-onehub/tokens';

const isInvertedThemeForm = (): boolean => false;

export const COLOR_TOKEN = isInvertedThemeForm() ? invertedThemeColorsNBD : mainThemeColorsNBD;

export const hexWithOpacity = (hex: string, opacity: number): string => {
	const alpha = Math.round(opacity * 255)
		.toString(16)
		.padStart(2, '0');
	return `${hex.replace('#', '#')}${alpha}`;
};

// --- CUSTOM ---
// novedades.tsx
export const novedadesBackgroundColor = `linear-gradient(180deg, ${COLOR_TOKEN.background.tertiary} 0%, ${COLOR_TOKEN.background.highlight} 67%)`;

// hucha (card, pdf & popup)
export const huchaLinesColor = globalColorsNBD.newHorizon['50'];

// bono posventa bg (card, pdf & popup)
export const bonoPosventaBackgroundColor = '#5d86da';

// accordion-styled.tsx
export const focusColorWithOpacity10 = hexWithOpacity(COLOR_TOKEN.focus.main, 0.1);

// services-animated-background.tsx
export const stain1Color = hexWithOpacity(globalColorsNBD.red['20'], 0.35);
export const stain3Color = hexWithOpacity(COLOR_TOKEN.focus.main, 0.35);
export const stain2Color = globalColorsNBD.yellow['20'];

// data-collection-progress-bar.tsx
export const dataCollectionProgressBarBackgroundColor = {
	level0: `linear-gradient(90deg, ${COLOR_TOKEN.background.offer} 0%, ${COLOR_TOKEN.accent.offer.default} 100%)`,
	level1: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.border.legalframe} 100%)`,
	level2: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.displayTag.bookmark.background} 100%)`,
	level3: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.displayTag.success.background} 100%)`,
};

// person-vehicle.tsx
export const signalErrorColorWithOpacity10 = hexWithOpacity(COLOR_TOKEN.signal.error, 0.1);
export const contentSecondaryWithOpacity10 = hexWithOpacity(COLOR_TOKEN.content.secondary, 0.1);

// notification-icon.tsx
export const notificationIconColor = globalColorsNBD.red['50'];

// benefits-helper.tsx
export const pastelGreen = globalColorsNBD.green['20'];
export const pastelOrange = globalColorsNBD.amber['30'];
